export const buildRangeText = (min, max) => {
    const hasDash = min && max ? " - " : "";
    const minNum = !max ? `≥ ${min}` : min || "";
    const maxNum = !min ? `≤ ${max}` : max || "";

    return !!min || !!max ? `${minNum}${hasDash}${maxNum}` : "All";
};
